import { css } from 'styled-components'
import Media from 'components/common/Media'

export default () => css`
  ${Media.mobile`
    display: none;
  `}
`
